import { AppConfig } from "config";
import { getToken } from "shared/src/helpers/token";
import { BaseRestClient } from "shared/src/http";

export const authClient = new BaseRestClient({ axiosConfig: { baseURL: AppConfig.urlAuthNode }, getToken });
export const dashClient = new BaseRestClient({ axiosConfig: { baseURL: AppConfig.apiUrl }, getToken });
